import { useCallback } from 'react';
import { useFlagService } from '@atlassian/jira-flags';
import { useRouterActions } from '@atlassian/react-resource-router';
import { ERROR_FLAG_ID } from '../../common/constants.tsx';
import messages from './messages.tsx';

export const useShowFlags = (projectUrl: string) => {
	const { showFlag, dismissFlag } = useFlagService();
	const { push } = useRouterActions();

	const goToSettings = useCallback(() => {
		if (projectUrl) {
			dismissFlag({ id: ERROR_FLAG_ID, command: 'DISMISS' });
			push(`${projectUrl}/settings/features`);
		}
	}, [dismissFlag, projectUrl, push]);

	const showErrorFlag = useCallback(
		() =>
			showFlag({
				id: ERROR_FLAG_ID,
				type: 'error',
				title: messages.errorFlagTitle,
				description: messages.errorFlagDescription,
				messageId: 'tmp-feature-toggle.controllers.use-show-flags.show-flag.error',
				messageType: 'transactional',
				actions: [
					{
						content: messages.errorFlagSettingsLink,
						onClick: goToSettings,
					},
				],
				isAutoDismiss: true,
			}),
		[goToSettings, showFlag],
	);

	return { showErrorFlag };
};
